import { render, staticRenderFns } from "./KemasanEmas.vue?vue&type=template&id=582412cc&"
import script from "./KemasanEmas.vue?vue&type=script&lang=js&"
export * from "./KemasanEmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports